export const getHostFromUrl = (_url) => {
    const url = new URL(_url);
    const hostName = url.hostname;
    const port = url.port ? `:${url.port}` : '';
    return `${hostName}${port}`;
};
//# sourceMappingURL=getHostFromUrl.js.map